import {atom, DefaultValue, selector} from 'recoil';

const userIdState = atom({
  key: 'user_profile_id',
  default: '',
});

const userCompanyState = atom({
  key: 'user_profile_company',
  default: '',
});

const userFirstNameState = atom({
  key: 'user_profile_first_name',
  default: '',
});

const userLastNameState = atom({
  key: 'user_profile_last_name',
  default: '',
});

const userUsernameState = atom({
  key: 'user_profile_username',
  default: '',
});

const userEmailState = atom({
  key: 'user_profile_email',
  default: '',
});

const userAddressState = atom({
  key: 'user_profile_address',
  default: '',
});

const userCityState = atom({
  key: 'user_profile_city',
  default: '',
});

const userCountryState = atom({
  key: 'user_profile_country',
  default: '',
});

const userZipCodeState = atom({
  key: 'user_profile_zip_code',
  default: '',
});

const userBiographyState = atom({
  key: 'user_profile_biography',
  default: '',
});

const userImageState = atom({
  key: 'user_profile_image',
  default: 1,
});

const userLoadingState = atom({
  key: 'user_profile_loading',
  default: true,
});

const userSavingState = atom({
  key: 'user_profile_saving',
  default: false,
});

const userErrorState = atom({
  key: 'user_profile_error',
  default: '',
});

const userProfileFormState = selector({
  key: 'userForm',
  get: ({get}) => {
    // get values from individual atoms:
    const id = get(userIdState);
    const company = get(userCompanyState);
    const firstName = get(userFirstNameState);
    const lastName = get(userLastNameState);
    const username = get(userUsernameState);
    const email = get(userEmailState);
    const address = get(userAddressState);
    const city = get(userCityState);
    const country = get(userCountryState);
    const zipCode = get(userZipCodeState);
    const biography = get(userBiographyState);
    const image = get(userImageState)
    const loading = get(userLoadingState);
    const saving = get(userSavingState);
    const error = get(userErrorState);
    return {id, company, firstName, lastName, username, email, address, city, country, zipCode, biography, image, loading, saving, error};
  },
  set: ({set}, value) => {
    if (value instanceof DefaultValue) {
      set(userIdState, value);
      set(userCompanyState, value);
      set(userFirstNameState, value);
      set(userLastNameState, value);
      set(userUsernameState, value);
      set(userEmailState, value);
      set(userAddressState, value);
      set(userCityState, value);
      set(userCountryState, value);
      set(userZipCodeState, value);
      set(userBiographyState, value);
      set(userImageState, value);
      set(userLoadingState, value);
      set(userSavingState, value);
      set(userErrorState, value);
      return;
    }
    set(userIdState, value.id);
    set(userCompanyState, value.company);
    set(userFirstNameState, value.firstName);
    set(userLastNameState, value.lastName);
    set(userUsernameState, value.username);
    set(userEmailState, value.email);
    set(userAddressState, value.address);
    set(userCityState, value.city);
    set(userCountryState, value.country);
    set(userZipCodeState, value.zipCode);
    set(userBiographyState, value.biography);
    set(userImageState, value.image);
    set(userLoadingState, value.loading);
    set(userSavingState, value.saving);
    set(userErrorState, value.error);
  },
});

export { userProfileFormState }